export default ({ data, functions }) => {
  const { dispatch, sendMessage } = functions;
  const { message, visible } = data;
  const messageWithTrim = message && message.trim();

  dispatch(
    sendMessage({
      message: messageWithTrim,
      visible,
    })
  );
};
